import {
  EmailOTPSignupActionTypes,
  EMAIL_OTP_SIGNUP_FAIL,
  EMAIL_OTP_SIGNUP_LOADING,
  EMAIL_OTP_SIGNUP_SUCCESS,
  EmailOTPSignupState,
  EMAIL_OTP_SIGNUP_UPDATE_API_MSG,
  EMAIL_OTP_SIGNUP_UPDATE_API_RES,
} from "./ActionTypes";
import { EmailOTPSignUpRes } from "./Model";

const initialStateGetPosts: EmailOTPSignupState = {
  loading: false,
  emailOTPSignUpRes: {} as EmailOTPSignUpRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const emailOtpSignupReducer = (
  state = initialStateGetPosts,
  action: EmailOTPSignupActionTypes
): EmailOTPSignupState => {
  switch (action.type) {
    case EMAIL_OTP_SIGNUP_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case EMAIL_OTP_SIGNUP_SUCCESS:
      return {
        ...state,
        emailOTPSignUpRes: action.payload,
        successMsg: action.successMsg,
      };
    case EMAIL_OTP_SIGNUP_FAIL:
      return {
        ...state,
        emailOTPSignUpRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case EMAIL_OTP_SIGNUP_UPDATE_API_MSG:
      return {
        ...state,
        emailOTPSignUpRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case EMAIL_OTP_SIGNUP_UPDATE_API_RES:
      return {
        ...state,
        emailOTPSignUpRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};

